module.exports = __webpack_public_path__ + "static/media/pptx.318bbb66.svg";